import { lazy } from "react";

export const LandingFooternAsync = lazy(() => import("./LandingFooter"));
